import pinyin from 'js-pinyin'

export const getPinyin = (str, separator = '', charCase = 1) => {
  if (typeof (str) !== 'string') {
    throw new Error(-1, '需要字符串类型参数!')
  }
  let len = str.length
  let arr = []
  for (let i = 0; i < len; i++) {
    let ch = str.substr(i, 1)
    let unicode = ch.charCodeAt(0)
    // 如果不在汉字处理范围之内,返回原字符,也可以调用自己的处理函数
    if (unicode > 40869 || unicode < 19968) {
      arr.push(ch)
    } else {
      let name = pinyin._getFullChar(ch)
      if (name !== false) {
        arr.push(name)
      }
    }
  }
  let result = arr.join(separator)

  if (charCase === 1) {
    result = result.toLowerCase()
  } else if (charCase === 2) {
    result = result.toUpperCase()
  }
  return result
}



// WEBPACK FOOTER //
// ./src/utils/pinyin/index.js